import ReactDOM from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";

import App from "./App";
import ErrorFallback from "./ui/ErrorFallback";

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);
root.render(
  <ErrorBoundary
    FallbackComponent={ErrorFallback}
    onReset={() => window.location.replace("/")}
  >
    <App />
  </ErrorBoundary>
);
